import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// UI strings are written in English and used as their own keys: with no resources,
// t() returns the key with its {{placeholders}} filled. Keys are full sentences, so
// ":" and "." must not be read as namespace or nesting separators.
i18n.use(initReactI18next).init({
  lng: "en",
  resources: {},
  nsSeparator: false,
  keySeparator: false,
  interpolation: { escapeValue: false },
  initImmediate: false,
  react: { useSuspense: false },
});

export default i18n;
